const API_URL = '/waste-customer-contract-file'

export const state = () => ({
  file: null,
})

export const getters = {
  get: state => {
    return state.file
  },
}

export const mutations = {
  SET_WASTE_CUSTOMER_CONTRACT_FILE(state, file) {
    state.file = file
  },
  REMOVE_WASTE_CUSTOMER_CONTRACT_FILE(state) {
    state.file = null
  },
}

export const actions = {
  fetch({ commit }, waste_customer_contract_file_id) {
    let { data } = useApi(`${API_URL}/${waste_customer_contract_file_id}`, {
      responseType: 'blob',
    })

    return data.value
  },
  async store({ commit }, waste_customer_contract_file) {
    let formData = new FormData()
    formData.append('file', waste_customer_contract_file)

    let { data: data } = await useApi(API_URL, {
      method: 'post',
      body: formData,
    })
    waste_customer_contract_file.id = data.value

    commit('SET_WASTE_CUSTOMER_CONTRACT_FILE', waste_customer_contract_file)

    return waste_customer_contract_file
  },
  async delete({ commit }, waste_customer_contract_file_id) {
    await useApi(`${API_URL}/${waste_customer_contract_file_id}`, { method: 'delete' })

    commit('REMOVE_WASTE_CUSTOMER_CONTRACT_FILE')
  },
}
